import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-order-search-form',
  templateUrl: './order-search-form.component.html',
  styleUrls: ['./order-search-form.component.scss']
})
export class OrderSearchFormComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() loading: boolean;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSubmit = new EventEmitter<void>(); // TODO

  constructor() {}

  ngOnInit(): void {}

  sumbitForm(): void {
    this.onSubmit.emit();
  }
}
